"use strict";
//to do, check chat gpt for the updated code,
//chnage the call state when new call is started with noah,
// sign over controls to the new calls with noah
// turn down the valume of the music
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
//import ModalWindow
var ModalWindow_1 = __importDefault(require("./ModalWindow"));
var config_1 = __importDefault(require("../../constants/config"));
require("bootstrap/dist/css/bootstrap.min.css");
function ChatWidget() {
    // state variable to track if widget button was hovered on
    var _a = (0, react_1.useState)(false), hovered = _a[0], setHovered = _a[1];
    // state variable to track modal visibility
    // const [visible, setVisible] = useState(false);
    var _b = (0, react_1.useState)(false), visible = _b[0], setVisible = _b[1];
    //creating a ref 'id'
    var widgetRef = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)("checking"), micStatus = _c[0], setMicStatus = _c[1];
    var _d = (0, react_1.useState)(config_1.default.agentName), currentAgentName = _d[0], setCurrentAgentName = _d[1];
    var _e = (0, react_1.useState)(config_1.default.textOne), currentStage = _e[0], setCurrentStage = _e[1];
    // use effect listener to check if the mouse was cliked outside the window 
    (0, react_1.useEffect)(function () {
        function handleClickOutside(event) {
            if (widgetRef.current && !widgetRef.current.contains(event.target)) {
                // setVisible(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [widgetRef]);
    // Callback function to update the parent's state
    // useEffect(() => {
    //     const checkMic = async () => {
    //       try {
    //         const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    //         // Microphone is active
    //         setMicStatus("active");
    //         setVisible(true);
    //         // Stop the tracks immediately if you're not using the stream
    //         stream.getTracks().forEach((track) => track.stop());
    //       } catch (error) {
    //         // Microphone is inactive or access denied
    //         if (error.name === "NotAllowedError" || error.message === "name") {
    //           setMicStatus("denied");
    //           setVisible(false);
    //         } else {
    //           setMicStatus("inactive");
    //           setVisible(false);
    //         }
    //       }
    //     };
    //     checkMic();
    //   }, []);
    function checkMic() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (navigator.mediaDevices && !visible) {
                    navigator.mediaDevices
                        .getUserMedia({ audio: true, video: false })
                        .then(function (stream) {
                        setMicStatus("active");
                        setVisible(!false);
                    }).catch(function (error) {
                        if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
                            setMicStatus("denied");
                        }
                        else if (error.name === "NotFoundError" || error.name === "DevicesNotFoundError") {
                            setMicStatus("denied");
                        }
                        else {
                            setMicStatus("denied");
                        }
                    });
                }
                else if (visible) {
                    setVisible(false);
                    setCurrentAgentName(config_1.default.agentName);
                    setCurrentStage('Speak With');
                }
                return [2 /*return*/];
            });
        });
    }
    // 🔁 This function allows you to update agent name and manage transfer behavior
    function handleAgentTransfer(newAgentName) {
        setCurrentAgentName(config_1.default.transferAgentName);
        setCurrentStage('Calling');
        setMicStatus("active");
        // setVisible(true);
    }
    // Optional: expose globally if you're triggering from outside the component
    (0, react_1.useEffect)(function () {
        window.transferToAgent = handleAgentTransfer;
    }, []);
    // 🔁 This function allows you to update agent name and manage transfer behavior
    function handleAgentHengUp(newAgentName) {
        setCurrentAgentName(config_1.default.agentName);
        setCurrentStage('Speak With');
        setMicStatus("active");
        setVisible(false);
    }
    // Optional: expose globally if you're triggering from outside the component
    (0, react_1.useEffect)(function () {
        window.hengUpAgent = handleAgentHengUp;
    }, []);
    var getChatText = function () {
        if (micStatus === "denied") {
            return {
                title: "Unable to call",
                subtitle: "".concat(currentAgentName, " For Help"),
            };
        }
        if (!visible) {
            return {
                title: "".concat(currentStage),
                subtitle: "".concat(currentAgentName, " For Help"),
            };
        }
        return {
            title: "End Call With",
            subtitle: "".concat(currentAgentName, " For Help"),
        };
    };
    var _f = getChatText(), title = _f.title, subtitle = _f.subtitle;
    return (
    //container
    //call widgetRef inside the div
    react_1.default.createElement("div", { ref: widgetRef },
        react_1.default.createElement(ModalWindow_1.default, { visible: visible, setVisible: setVisible }),
        react_1.default.createElement("div", { className: "chat-widget d-flex align-items-center  px-3 py-1 ", onClick: function () { return checkMic(); }, onMouseEnter: function () { return setHovered(true); }, onMouseLeave: function () { return setHovered(false); }, style: { cursor: "pointer", maxWidth: "100%", width: "15rem", } },
            react_1.default.createElement("div", { className: "chat-logo me-3" },
                react_1.default.createElement("img", { src: "https://scaleagilesolutions.com/wp-content/uploads/dist/logo.png", alt: "Logo", className: "chat-logo-img" })),
            react_1.default.createElement("div", { className: "chat-text" },
                react_1.default.createElement("p", { className: "chat-text-header text-white", style: { fontSize: '0.93rem' } }, title),
                subtitle && react_1.default.createElement("p", { className: "m-0 chat-subtitle chat-text-header text-white", style: { fontSize: '0.93rem' } }, subtitle),
                react_1.default.createElement("p", { className: " text-light opacity-70 text-end text-font-change", style: { fontSize: '0.4rem' } }, "Powered by ConnexUS AI")))));
}
exports.default = ChatWidget;
